'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["className", "color", "value", "valueBuffer", "variant"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import composeClasses from '@mui/utils/composeClasses';
import { darken, lighten } from '@mui/system/colorManipulator';
import { useRtl } from '@mui/system/RtlProvider';
import { keyframes, css, styled } from "../zero-styled/index.js";
import memoTheme from "../utils/memoTheme.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import capitalize from "../utils/capitalize.js";
import { getLinearProgressUtilityClass } from "./linearProgressClasses.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TRANSITION_DURATION = 4; // seconds
var indeterminate1Keyframe = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    left: -35%;\n    right: 100%;\n  }\n\n  60% {\n    left: 100%;\n    right: -90%;\n  }\n\n  100% {\n    left: 100%;\n    right: -90%;\n  }\n"])));

// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
var indeterminate1Animation = typeof indeterminate1Keyframe !== 'string' ? css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        animation: ", " 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;\n      "])), indeterminate1Keyframe) : null;
var indeterminate2Keyframe = keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  0% {\n    left: -200%;\n    right: 100%;\n  }\n\n  60% {\n    left: 107%;\n    right: -8%;\n  }\n\n  100% {\n    left: 107%;\n    right: -8%;\n  }\n"])));
var indeterminate2Animation = typeof indeterminate2Keyframe !== 'string' ? css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        animation: ", " 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;\n      "])), indeterminate2Keyframe) : null;
var bufferKeyframe = keyframes(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  0% {\n    opacity: 1;\n    background-position: 0 -23px;\n  }\n\n  60% {\n    opacity: 0;\n    background-position: 0 -23px;\n  }\n\n  100% {\n    opacity: 1;\n    background-position: -200px -23px;\n  }\n"])));
var bufferAnimation = typeof bufferKeyframe !== 'string' ? css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        animation: ", " 3s infinite linear;\n      "])), bufferKeyframe) : null;
var useUtilityClasses = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes,
    variant = ownerState.variant,
    color = ownerState.color;
  var slots = {
    root: ['root', "color".concat(capitalize(color)), variant],
    dashed: ['dashed', "dashedColor".concat(capitalize(color))],
    bar1: ['bar', "barColor".concat(capitalize(color)), (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate', variant === 'determinate' && 'bar1Determinate', variant === 'buffer' && 'bar1Buffer'],
    bar2: ['bar', variant !== 'buffer' && "barColor".concat(capitalize(color)), variant === 'buffer' && "color".concat(capitalize(color)), (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate', variant === 'buffer' && 'bar2Buffer']
  };
  return composeClasses(slots, getLinearProgressUtilityClass, classes);
};
var getColorShade = function getColorShade(theme, color) {
  if (theme.vars) {
    return theme.vars.palette.LinearProgress["".concat(color, "Bg")];
  }
  return theme.palette.mode === 'light' ? lighten(theme.palette[color].main, 0.62) : darken(theme.palette[color].main, 0.5);
};
var LinearProgressRoot = styled('span', {
  name: 'MuiLinearProgress',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, styles["color".concat(capitalize(ownerState.color))], styles[ownerState.variant]];
  }
})(memoTheme(function (_ref) {
  var theme = _ref.theme;
  return {
    position: 'relative',
    overflow: 'hidden',
    display: 'block',
    height: 4,
    // Fix Safari's bug during composition of different paint.
    zIndex: 0,
    '@media print': {
      colorAdjust: 'exact'
    },
    variants: [].concat(_toConsumableArray(Object.entries(theme.palette).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        value = _ref3[1];
      return value && value.main;
    }).map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 1),
        color = _ref5[0];
      return {
        props: {
          color: color
        },
        style: {
          backgroundColor: getColorShade(theme, color)
        }
      };
    })), [{
      props: function props(_ref6) {
        var ownerState = _ref6.ownerState;
        return ownerState.color === 'inherit' && ownerState.variant !== 'buffer';
      },
      style: {
        '&::before': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'currentColor',
          opacity: 0.3
        }
      }
    }, {
      props: {
        variant: 'buffer'
      },
      style: {
        backgroundColor: 'transparent'
      }
    }, {
      props: {
        variant: 'query'
      },
      style: {
        transform: 'rotate(180deg)'
      }
    }])
  };
}));
var LinearProgressDashed = styled('span', {
  name: 'MuiLinearProgress',
  slot: 'Dashed',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.dashed, styles["dashedColor".concat(capitalize(ownerState.color))]];
  }
})(memoTheme(function (_ref7) {
  var theme = _ref7.theme;
  return {
    position: 'absolute',
    marginTop: 0,
    height: '100%',
    width: '100%',
    backgroundSize: '10px 10px',
    backgroundPosition: '0 -23px',
    variants: [{
      props: {
        color: 'inherit'
      },
      style: {
        opacity: 0.3,
        backgroundImage: "radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)"
      }
    }].concat(_toConsumableArray(Object.entries(theme.palette).filter(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 2),
        value = _ref9[1];
      return value && value.main;
    }).map(function (_ref10) {
      var _ref11 = _slicedToArray(_ref10, 1),
        color = _ref11[0];
      var backgroundColor = getColorShade(theme, color);
      return {
        props: {
          color: color
        },
        style: {
          backgroundImage: "radial-gradient(".concat(backgroundColor, " 0%, ").concat(backgroundColor, " 16%, transparent 42%)")
        }
      };
    })))
  };
}), bufferAnimation || {
  // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
  animation: "".concat(bufferKeyframe, " 3s infinite linear")
});
var LinearProgressBar1 = styled('span', {
  name: 'MuiLinearProgress',
  slot: 'Bar1',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.bar, styles["barColor".concat(capitalize(ownerState.color))], (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate, ownerState.variant === 'determinate' && styles.bar1Determinate, ownerState.variant === 'buffer' && styles.bar1Buffer];
  }
})(memoTheme(function (_ref12) {
  var theme = _ref12.theme;
  return {
    width: '100%',
    position: 'absolute',
    left: 0,
    bottom: 0,
    top: 0,
    transition: 'transform 0.2s linear',
    transformOrigin: 'left',
    variants: [{
      props: {
        color: 'inherit'
      },
      style: {
        backgroundColor: 'currentColor'
      }
    }].concat(_toConsumableArray(Object.entries(theme.palette).filter(function (_ref13) {
      var _ref14 = _slicedToArray(_ref13, 2),
        value = _ref14[1];
      return value && value.main;
    }).map(function (_ref15) {
      var _ref16 = _slicedToArray(_ref15, 1),
        color = _ref16[0];
      return {
        props: {
          color: color
        },
        style: {
          backgroundColor: (theme.vars || theme).palette[color].main
        }
      };
    })), [{
      props: {
        variant: 'determinate'
      },
      style: {
        transition: "transform .".concat(TRANSITION_DURATION, "s linear")
      }
    }, {
      props: {
        variant: 'buffer'
      },
      style: {
        zIndex: 1,
        transition: "transform .".concat(TRANSITION_DURATION, "s linear")
      }
    }, {
      props: function props(_ref17) {
        var ownerState = _ref17.ownerState;
        return ownerState.variant === 'indeterminate' || ownerState.variant === 'query';
      },
      style: {
        width: 'auto'
      }
    }, {
      props: function props(_ref18) {
        var ownerState = _ref18.ownerState;
        return ownerState.variant === 'indeterminate' || ownerState.variant === 'query';
      },
      style: indeterminate1Animation || {
        animation: "".concat(indeterminate1Keyframe, " 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite")
      }
    }])
  };
}));
var LinearProgressBar2 = styled('span', {
  name: 'MuiLinearProgress',
  slot: 'Bar2',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.bar, styles["barColor".concat(capitalize(ownerState.color))], (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate, ownerState.variant === 'buffer' && styles.bar2Buffer];
  }
})(memoTheme(function (_ref19) {
  var theme = _ref19.theme;
  return {
    width: '100%',
    position: 'absolute',
    left: 0,
    bottom: 0,
    top: 0,
    transition: 'transform 0.2s linear',
    transformOrigin: 'left',
    variants: [].concat(_toConsumableArray(Object.entries(theme.palette).filter(function (_ref20) {
      var _ref21 = _slicedToArray(_ref20, 2),
        value = _ref21[1];
      return value && value.main;
    }).map(function (_ref22) {
      var _ref23 = _slicedToArray(_ref22, 1),
        color = _ref23[0];
      return {
        props: {
          color: color
        },
        style: {
          '--LinearProgressBar2-barColor': (theme.vars || theme).palette[color].main
        }
      };
    })), [{
      props: function props(_ref24) {
        var ownerState = _ref24.ownerState;
        return ownerState.variant !== 'buffer' && ownerState.color !== 'inherit';
      },
      style: {
        backgroundColor: 'var(--LinearProgressBar2-barColor, currentColor)'
      }
    }, {
      props: {
        color: 'inherit'
      },
      style: {
        opacity: 0.3
      }
    }], _toConsumableArray(Object.entries(theme.palette).filter(function (_ref25) {
      var _ref26 = _slicedToArray(_ref25, 2),
        value = _ref26[1];
      return value && value.main;
    }).map(function (_ref27) {
      var _ref28 = _slicedToArray(_ref27, 1),
        color = _ref28[0];
      return {
        props: {
          color: color,
          variant: 'buffer'
        },
        style: {
          backgroundColor: getColorShade(theme, color),
          transition: "transform .".concat(TRANSITION_DURATION, "s linear")
        }
      };
    })), [{
      props: function props(_ref29) {
        var ownerState = _ref29.ownerState;
        return ownerState.variant === 'indeterminate' || ownerState.variant === 'query';
      },
      style: {
        width: 'auto'
      }
    }, {
      props: function props(_ref30) {
        var ownerState = _ref30.ownerState;
        return ownerState.variant === 'indeterminate' || ownerState.variant === 'query';
      },
      style: indeterminate2Animation || {
        animation: "".concat(indeterminate2Keyframe, " 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite")
      }
    }])
  };
}));

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
var LinearProgress = /*#__PURE__*/React.forwardRef(function LinearProgress(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiLinearProgress'
  });
  var className = props.className,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    value = props.value,
    valueBuffer = props.valueBuffer,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
    other = _objectWithoutProperties(props, _excluded);
  var ownerState = _objectSpread(_objectSpread({}, props), {}, {
    color: color,
    variant: variant
  });
  var classes = useUtilityClasses(ownerState);
  var isRtl = useRtl();
  var rootProps = {};
  var inlineStyles = {
    bar1: {},
    bar2: {}
  };
  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      rootProps['aria-valuemin'] = 0;
      rootProps['aria-valuemax'] = 100;
      var transform = value - 100;
      if (isRtl) {
        transform = -transform;
      }
      inlineStyles.bar1.transform = "translateX(".concat(transform, "%)");
    } else if (process.env.NODE_ENV !== 'production') {
      console.error('MUI: You need to provide a value prop ' + 'when using the determinate or buffer variant of LinearProgress .');
    }
  }
  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      var _transform = (valueBuffer || 0) - 100;
      if (isRtl) {
        _transform = -_transform;
      }
      inlineStyles.bar2.transform = "translateX(".concat(_transform, "%)");
    } else if (process.env.NODE_ENV !== 'production') {
      console.error('MUI: You need to provide a valueBuffer prop ' + 'when using the buffer variant of LinearProgress.');
    }
  }
  return /*#__PURE__*/_jsxs(LinearProgressRoot, _objectSpread(_objectSpread(_objectSpread({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    role: "progressbar"
  }, rootProps), {}, {
    ref: ref
  }, other), {}, {
    children: [variant === 'buffer' ? /*#__PURE__*/_jsx(LinearProgressDashed, {
      className: classes.dashed,
      ownerState: ownerState
    }) : null, /*#__PURE__*/_jsx(LinearProgressBar1, {
      className: classes.bar1,
      ownerState: ownerState,
      style: inlineStyles.bar1
    }), variant === 'determinate' ? null : /*#__PURE__*/_jsx(LinearProgressBar2, {
      className: classes.bar2,
      ownerState: ownerState,
      style: inlineStyles.bar2
    })]
  }));
});
process.env.NODE_ENV !== "production" ? LinearProgress.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['inherit', 'primary', 'secondary']), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: PropTypes.number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */
  variant: PropTypes.oneOf(['buffer', 'determinate', 'indeterminate', 'query'])
} : void 0;
export default LinearProgress;